import { QR_OVERVIEW, QR_LIST } from "@/apollo/queries/qr";
import { exQue } from "@/utils/gql";

// Resumen de lecturas del módulo (qrAdminOverview) y las opciones del selector
// "Código QR" del dashboard.
//
// El estado es una función por la misma razón que en Carpetas.js: CLEAR (storeQr.js) lo
// vacía al cerrar sesión, porque las lecturas de una empresa no deben verse mientras
// carga la siguiente.
export const DashboardState = () => ({
  resumen: null,
  resumenCargando: false,
  opcionesQr: [],
  opcionesQrCargando: false,
  // Verdadero cuando hay más QR de los que caben en el selector (100)
  opcionesQrIncompletas: false,
});

export const DashboardMutations = {
  setResumen(state, resumen) {
    state.resumen = resumen;
  },
  setResumenCargando(state, cargando) {
    state.resumenCargando = cargando;
  },
  setOpcionesQr(state, { opciones, incompletas }) {
    state.opcionesQr = opciones;
    state.opcionesQrIncompletas = incompletas;
  },
  setOpcionesQrCargando(state, cargando) {
    state.opcionesQrCargando = cargando;
  },
};

// Número de la última consulta de cada tipo. Los filtros se aplican solos mientras se
// escribe, así que salen varias seguidas y pueden volver desordenadas: solo la última
// cuenta.
let consultaResumen = 0;
let consultaOpciones = 0;

export const DashboardActions = {
  // Lecturas y conteos del período y los filtros elegidos. `filtros` es lo que acepta
  // qrAdminOverview: { from, to, allTime, folderId, archive, qrId }. Devuelve el resumen,
  // o false si una consulta más nueva la reemplazó o si falló.
  async getResumen({ commit }, filtros) {
    const consulta = ++consultaResumen;
    commit("setResumenCargando", true);
    try {
      const resumen = await exQue(
        QR_OVERVIEW,
        filtros,
        true,
        "",
        "No se pudieron cargar las lecturas",
      );
      if (consulta !== consultaResumen) return false;
      commit("setResumen", resumen);
      return resumen;
    } catch (_) {
      // exQue ya avisó con un toast; el dashboard deja lo que había en pantalla
      return false;
    } finally {
      if (consulta === consultaResumen) commit("setResumenCargando", false);
    }
  },

  // Opciones del selector "Código QR", buscadas en el servidor. Conserva el QR ya elegido
  // aunque no venga en la página nueva: si no, el filtro aplicado se vería vacío.
  async getOpcionesQr(
    { commit, state },
    { busqueda = "", folderId = "", archive = "all", seleccionado = "" } = {},
  ) {
    const consulta = ++consultaOpciones;
    commit("setOpcionesQrCargando", true);
    try {
      const pagina = await exQue(
        QR_LIST,
        { search: busqueda, offset: 0, limit: 100, folderId, archive },
        true,
        "",
        "No se pudieron cargar los códigos QR",
      );
      if (consulta !== consultaOpciones) return false;
      const items = pagina?.items || [];
      const elegido = state.opcionesQr.find((fila) => fila.id === seleccionado);
      const opciones =
        elegido && !items.some((fila) => fila.id === elegido.id)
          ? [elegido, ...items]
          : items;
      commit("setOpcionesQr", {
        opciones,
        incompletas: Number(pagina?.total) > 100,
      });
      return pagina;
    } catch (_) {
      return false;
    } finally {
      if (consulta === consultaOpciones) commit("setOpcionesQrCargando", false);
    }
  },
};
